export const PageName = {
  TOP: 'TOP',
  DATA_SHARE_TOP: 'DataShareTop',
  BSC_HC_010_001: 'BSC-HC-010-001',
  BSC_HC_020_002: 'BSC-HC-020-002',
  BSC_HC_020_003: 'BSC_HC_020_003',
  BSC_HC_020_004: 'BSC-HC-020-004',
  BSC_HC_020_006: 'BSC-HC-020-006',
  BSC_HC_020_012: 'BSC-HC-020-012',
  BSC_HC_040_001: 'BSC-HC-040-001',
  BSC_HC_040_002: 'BSC-HC-040-002',
  BSC_HC_040_004: 'BSC_HC-040-004',
  BSC_HC_040_006: 'BSC-HC-040-006',
  BSC_HC_040_007: 'BSC-HC-040-007',
  BSC_HC_040_008: 'BSC-HC-040-008',
  BSC_HC_040_010: 'BSC-HC-040-010',
  BSC_HC_040_011: 'BSC-HC-040-011',
  BSC_HC_040_012: 'BSC-HC-040-012',
  BSC_HC_040_013: 'BSC-HC-040-013',
  BSC_HC_040_015: 'BSC-HC-040-015',
  BSC_HC_040_023: 'BSC-HC-040-023',
  BSC_HC_040_026: 'BSC_HC-040-026',
  BSC_HC_040_027: 'BSC_HC-040-027',
  BSC_HC_040_029: 'BSC_HC-040-029',
  BSC_HC_040_032: 'BSC_HC-040-032',
  BSC_HC_040_033: 'BSC-HC-040-033',
  BSC_HC_040_035: 'BSC_HC-040-035',
  BSC_HC_040_036: 'BSC-HC-040-036',
  BSC_HC_040_037: 'BSC_HC-040-037',
  BSC_HC_040_040: 'BSC-HC-040-040',
  BSC_HC_040_041: 'BSC-HC-040-041',
  BSC_HC_040_042: 'BSC-HC-040-042',
  BSC_HC_040_043: 'BSC-HC-040-043',
  BSC_HC_040_044: 'BSC-HC-040-044',
  BSC_HC_040_045: 'BSC-HC-040-045',
  BSC_HC_040_046: 'BSC-HC-040-046',
  BSC_HC_040_052: 'BSC-HC-040-052',
  BSC_HC_040_053: 'BSC-HC-040-053',
  BSC_HC_040_054: 'BSC-HC-040-054',
  BSC_HC_040_055: 'BSC-HC-040-055',
  BSC_HC_040_057: 'BSC_HC-040-057',
  BSC_HC_040_058: 'BSC_HC-040-058',
  BSC_HC_040_059: 'BSC_HC-040-059',
  BSC_HC_040_060: 'BSC_HC-040-060',
  BSC_HC_040_067: 'BSC-HC-040-067',
  BSC_HC_040_068: 'BSC-HC-040-068',
  BSC_HC_040_069: 'BSC-HC-040-069',
  BSC_HC_040_061: 'BSC_HC_040_061',
  BSC_HC_040_065: 'BSC-HC-040-065',
  BSC_HC_040_066: 'BSC-HC-040-066',
  BSC_HC_040_070: 'BSC-HC-040-070',
  BSC_HC_040_072: 'BSC-HC-040-072',
  BSC_HC_040_074: 'BSC-HC-040-074',
  BSC_HC_040_076: 'BSC-HC-040-076',
  BSC_HC_060_001: 'BSC-HC-060-001',
  BSC_HC_060_002: 'BSC-HC-060-002',
  BSC_HC_060_003: 'BSC-HC-060-003',
  BSC_HC_060_004: 'BSC-HC-060-004',
  BSC_HC_060_010: 'BSC-HC-060-010',
  BSC_HC_060_013: 'BSC-HC-060-013',
  BSC_HC_060_014: 'BSC-HC-060-014',
  BSC_HC_060_021: 'BSC-HC-060-021',
  BSC_HC_060_024: 'BSC-HC-060-024',
  BSC_HC_060_025: 'BSC-HC-060-025',
  BSC_HC_060_026: 'BSC-HC-060-026',
  BSC_HC_060_027: 'BSC-HC-060-027',
  BSC_HC_060_028: 'BSC-HC-060-028',
  BSC_HC_080_001: 'BSC-HC-080-001',
  BSC_HC_080_003: 'BSC-HC-080-003',
  BSC_HC_080_004: 'BSC-HC-080-004',
  BSC_HC_130_001: 'BSC-HC-130-001',
  BSC_MN_420_001: 'BSC-MN-420-001',
  BSC_MN_420_002: 'BSC-MN-420-002',
  BSC_MN_420_003: 'BSC-MN-420-003',
  BSC_MN_420_010: 'BSC-MN-420-010',
  BSC_MN_420_011: 'BSC-MN-420-011',
  BSC_MN_420_013: 'BSC-MN-420-013',
  BSC_MN_420_014: 'BSC-MN-420-014',
  BSC_MN_420_015: 'BSC-MN-420-015',
  BSC_MN_420_016: 'BSC-MN-420-016',
  BSC_MN_450_001: 'BSC-MN-450-001',
  BSC_MN_450_014: 'BSC-MN-450-014',
  BSC_MN_450_015: 'BSC-MN-450-015',
  BSC_MN_450_016: 'BSC-MN-450-016',
  BSC_MN_450_017: 'BSC-MN-450-017',
  BSC_MN_450_019: 'BSC-MN-450-019',
  BSC_MN_450_020: 'BSC-MN-450-020',
  BSC_MN_450_026: 'BSC-MN-450-026',
  BSC_MN_450_027: 'BSC-MN-450-027',
  BSC_MN_450_028: 'BSC-MN-450-028',
  BSC_MN_450_029: 'BSC-MN-450-029',
  BSC_MN_450_030: 'BSC-MN-450-030',
  BSC_MN_450_030_2: 'BSC-MN-450-030-2',
  BSC_MN_450_032: 'BSC-MN-450-032',
  BSC_MN_450_033: 'BSC-MN-450-033',
  BSC_MN_470_001: 'BSC-MN-470-001',
  BSC_MN_470_010: 'BSC-MN-470-010',
  BSC_MN_480_001: 'BSC-MN-480-001',
  BSC_MN_480_002: 'BSC-MN-480-002',
  BSC_MN_480_003: 'BSC-MN-480-003',
  BSC_MN_480_004: 'BSC-MN-480-004',
  BSC_MN_520_001: 'BSC-MN-520-001',
  BSC_MN_530_001: 'BSC-MN-530-001',
  BSC_MN_530_XXX: 'BSC-MN-530-XXX',
  // BSC_MN_530_002: 'BSC-MN-530-002',
  // BSC_MN_530_003: 'BSC-MN-530-003',
  // BSC_MN_530_004: 'BSC-MN-530-004',
  // BSC_MN_530_005: 'BSC-MN-530-005',
  // BSC_MN_530_006: 'BSC-MN-530-006',
  // BSC_MN_530_007: 'BSC-MN-530-007',
  BSC_MN_530_009: 'BSC-MN-530-009',
  BSC_MN_530_011: 'BSC-MN-530-011',
  BSC_MN_530_013: 'BSC-MN-530-013',
  BSC_MN_530_014: 'BSC-MN-530-014',
  BSC_MN_420_005: 'BSC-MN-420-005',
  BSC_MN_420_009: 'BSC-MN-420-009',
  BSC_MN_450_003: 'BSC-MN-450-003',
  BSC_MN_450_008: 'BSC-MN-450-008',
  BSC_MN_450_011: 'BSC-MN-450-011',
  BSC_MN_450_013: 'BSC-MN-450-013',
  BSC_MN_460_006: 'BSC-MN-460-006',
  BSC_MN_460_007: 'BSC-MN-460-007',
  BSC_MN_400_001: 'BSC-MN-400-001',
  BSC_MN_400_002: 'BSC-MN-400-002',
  BSC_MN_400_003: 'BSC-MN-400-003',
  BSC_MN_400_004: 'BSC-MN-400-004',
  BSC_MN_400_010: 'BSC-MN-400-010',
  BSC_MN_400_011: 'BSC-MN-400-011',
  BSC_MN_400_012: 'BSC-MN-400-012',
  BSC_HC_040_071: 'BSC-HC-040-071',
  BSC_HC_040_075: 'BSC-HC-040-075',
  // FIXME: 動作確認用
  BSC_MN_470_009: 'BCS-MN-470-009',
} as const;

export default PageName;
